import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getData } from '../Services/api';
import Pagination from '../Services/Pagination';

const OrderList = () => {
    const navigate = useNavigate();

    const [orders, setOrders] = useState([]);
    const [stats, setStats] = useState(null);

    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [activeTab, setActiveTab] = useState('all');
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    /* ================= FETCH ORDERS ================= */
    const fetchOrders = async (pageNumber = page) => {
        try {
            setLoading(true);

            const finalStatus =
                activeTab !== 'all'
                    ? activeTab
                    : statusFilter !== 'all'
                        ? statusFilter
                        : '';

            const res = await getData(
                `/orders/all?page=${pageNumber}&search=${searchTerm}&status=${finalStatus}`
            );

            console.log(res)
            if (res.status) {
                setOrders(res.data);
                setPage(res.pagination.page);
                setPages(res.pagination.totalPages);
                setTotal(res.pagination.total);

            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* ================= FETCH STATS ================= */
    const fetchStats = async () => {
        try {
            const res = await getData('/orders/stats');
            console.log('stats', res)
            setStats(res.data.data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchOrders();
    }, [page, searchTerm, statusFilter, activeTab]);
    const handlePageChange = (pageNumber) => {
        if (pageNumber !== page) {
            setPage(pageNumber);
        }
    };

    useEffect(() => {
        fetchStats();
    }, []);

    const getBadgeClass = (status) => {
        switch (status) {
            case 'PLACED':
                return 'bg-secondary';
            case 'CONFIRMED':
                return 'bg-primary';
            case 'SHIPPED':
                return 'bg-warning text-dark';
            case 'DELIVERED':
                return 'bg-success';
            case 'CANCELLED':
                return 'bg-danger';
            default:
                return 'bg-secondary';
        }
    };

    return (
        <div className="pc-container">
            <div className="pc-content">

                {/* Header */}
                <div className="mb-4">
                    <h2 className="fw-bold">Order Management</h2>
                    <p className="text-muted">Process and track all customer orders</p>
                </div>

                {/* Stats */}
                {stats && (
                    <div className="row g-3 mb-4">
                        <div className="col-md-3">
                            <div className="card p-3">
                                <p className="text-muted mb-1">Total Orders</p>
                                <h4>{stats.totalOrders}</h4>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card p-3">
                                <p className="text-muted mb-1">Pending Orders</p>
                                <h4>{stats.placed || 0}</h4>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card p-3">
                                <p className="text-muted mb-1">Processing</p>
                                <h4>{stats.confirmed || 0}</h4>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card p-3">
                                <p className="text-muted mb-1">Total Revenue</p>
                                <h4>₹{stats.totalRevenue.toFixed(2)}</h4>
                            </div>
                        </div>
                    </div>
                )}

                {/* Filters */}
                <div className="card p-3 mb-4">
                    <div className="row g-3">
                        <div className="col-md-8">
                            <input
                                className="form-control"
                                placeholder="Search orders, customers, or emails..."
                                value={searchTerm}
                                onChange={(e) => {
                                    setPage(1);
                                    setSearchTerm(e.target.value);
                                }}
                            />
                        </div>

                        <div className="col-md-4">
                            <select
                                className="form-select"
                                value={statusFilter}
                                onChange={(e) => {
                                    setPage(1);
                                    setActiveTab('all');
                                    setStatusFilter(e.target.value);
                                }}
                            >
                                <option value="all">All Status</option>
                                <option value="PLACED">Placed</option>
                                <option value="CONFIRMED">Confirmed</option>
                                <option value="SHIPPED">Shipped</option>
                                <option value="DELIVERED">Delivered</option>
                                <option value="CANCELLED">Cancelled</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* Tabs */}
                <ul className="nav nav-tabs mb-3">
                    {['all', 'PLACED', 'CONFIRMED', 'SHIPPED', 'DELIVERED', 'CANCELLED'].map(tab => (
                        <li className="nav-item" key={tab}>
                            <button
                                className={`nav-link ${activeTab === tab ? 'active' : ''}`}
                                onClick={() => {
                                    setPage(1);
                                    setStatusFilter('all');
                                    setActiveTab(tab);
                                }}
                            >
                                {tab}
                            </button>
                        </li>
                    ))}
                </ul>

                {/* Table */}
                <div className="card">
                    <div className="table-responsive">
                        <table className="table table-bordered mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>Order</th>
                                    <th>Customer</th>
                                    <th>Date</th>
                                    <th>Status</th>
                                    <th>Items</th>
                                    <th>Total</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="7" className="text-center py-4">
                                            Loading...
                                        </td>
                                    </tr>
                                ) : orders.length === 0 ? (
                                    <tr>
                                        <td colSpan="7" className="text-center py-4">
                                            No orders found
                                        </td>
                                    </tr>
                                ) : (
                                    orders.map(order => (
                                        <tr key={order._id}>
                                            <td className="fw-bold">{order.orderId}</td>

                                            <td>
                                                <div className="fw-semibold">{order.user?.name}</div>
                                                <small className="text-muted">{order.user?.email}</small>
                                            </td>

                                            <td>{new Date(order.createdAt).toLocaleDateString()}</td>

                                            <td>
                                                <span className={`badge ${getBadgeClass(order.orderStatus)}`}>
                                                    {order.orderStatus}
                                                </span>
                                            </td>

                                            <td>{order.items.length}</td>

                                            <td className="fw-bold">₹{order.totalAmount.toFixed(2)}</td>

                                            <td>
                                                <Link to={`/orders/view-order/${order._id}`} className="btn btn-sm btn-outline-secondary me-2">
                                                    <i className="fas fa-eye"></i>
                                                </Link>

                                                <select className="form-select form-select-sm d-inline w-auto">
                                                    <option>PLACED</option>
                                                    <option>CONFIRMED</option>
                                                    <option>SHIPPED</option>
                                                    <option>DELIVERED</option>
                                                    <option>CANCELLED</option>
                                                </select>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                    <div className="text-muted">
                        Showing {(page - 1) * 10 + 1} to {Math.min(page * 10, total)} of {total} entries
                    </div>
                    <Pagination
                        page={page}
                        pages={pages}
                        onPageChange={handlePageChange}
                    />
                </div>

            </div>
        </div>
    );
};

export default OrderList;
